
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/52501c5195af983614e2b6722a904274.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/80 to-primary/70"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block text-sm font-semibold tracking-widest text-secondary uppercase mb-4">Schedule Your Consultation</span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight">
              Experience Premium Health Insurance Protection for Your Family
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Join 2,500+ Highland Park, University Park, and Preston Hollow families who trust Dallas Health Insurance Experts with their private health coverage. Free, no-obligation consultation.
            </p>

            <div className="space-y-4 mb-10">
              {[
                'Personalized plan comparison from 20+ premium carriers',
                'Access to Dallas\'s top medical institutions and physicians',
                'Concierge-level service — we handle everything for you',
                'Zero cost for our expert guidance and enrollment support'
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <i className="ri-check-double-line text-xl text-secondary mt-0.5"></i>
                  <span className="text-white text-sm">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 bg-secondary hover:bg-secondary/90 text-white text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
              >
                <i className="ri-calendar-line"></i>
                Book Private Consultation
              </Link>
              <a
                href="tel:+12143060121"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 hover:bg-white/20 text-white text-lg font-semibold rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                (214) 306-0121
              </a>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="text-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-secondary/20 rounded-full mx-auto mb-4">
                  <i className="ri-shield-star-line text-3xl text-secondary"></i>
                </div>
                <h3 className="text-2xl font-heading font-bold text-white mb-2">Why Clients Stay With Us</h3>
                <p className="text-sm text-gray-400">Average client relationship: 7+ years</p>
              </div>
              <div className="space-y-5">
                {[
                  { label: 'Client Satisfaction', value: '98%' },
                  { label: 'Client Retention Rate', value: '95%' },
                  { label: 'Average Annual Savings', value: '$3,200' },
                  { label: 'Claims Resolution Rate', value: '99%' },
                ].map((stat, i) => (
                  <div key={i} className="flex items-center justify-between py-3 border-b border-white/10 last:border-0">
                    <span className="text-gray-300 text-sm">{stat.label}</span>
                    <span className="text-white font-bold text-lg">{stat.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-400">
            <i className="ri-map-pin-line mr-1"></i>
            8300 Douglas Ave Ste 800, Dallas, TX 75225 &nbsp;|&nbsp;
            <i className="ri-time-line mr-1"></i>
            Mon-Fri 8am-6pm &nbsp;|&nbsp; Sat 9am-2pm
          </p>
        </div>
      </div>
    </section>
  );
}
